import { hexToRgb } from './color'

import type { ContestColor } from '@/types/index'

export const setRootCss = (colors: ContestColor): void => {
  const body = document.getElementsByTagName('body')[0]

  body.style.setProperty('--bg-primary', colors.backgroundColor)
  body.style.setProperty('--bg-primary-opacity', hexToRgb(colors.backgroundColor, 45))
  body.style.setProperty('--bg-button-primary', colors.buttonColor)
  body.style.setProperty('--text-primary', colors.textColor)
  body.style.setProperty('--text-button', colors.buttonTextColor)
}
